import { thunk } from 'easy-peasy';

import api from '~/services/api';
import { IThunkArchiveMedicaidPlan } from '../types';

const onArchiveMedicaidPlan: IThunkArchiveMedicaidPlan = thunk(
  async (_, { requestInfo, requestPayload }) => {
    await api.medicaidPlan.archiveMedicaidPlan(requestInfo, requestPayload);
  },
);

export default onArchiveMedicaidPlan;
